import { saveAs } from "file-saver";
import { utils, writeFile } from "xlsx";

export function exportToCSV(rows: (string | number)[][], headers: string[], filename: string) {
	const csvContent = [headers, ...rows].map(row => row.map(value => `"${value ?? ""}"`).join(",")).join("\n");

	const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
	saveAs(blob, filename);
}

export function exportToExcel(rows: (string | number)[][], headers: string[], filename: string) {
	if (rows.length === 0) return;

	const worksheet = utils.aoa_to_sheet([headers, ...rows]);
	const workbook = utils.book_new();
	utils.book_append_sheet(workbook, worksheet, "Sheet1");

	writeFile(workbook, filename);
}

export function exportToJSON<T>(data: T[], filename = "export.json") {
	saveAs(new Blob([JSON.stringify(data, null, 2)], { type: "application/json" }), filename);
}
